import { Component } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { ProvaFase } from 'src/app/enums/prova-fase'

@Component({
  selector: 'app-fase-selecao-dialog',
  templateUrl: './fase-selecao-dialog.component.html',
})
export class FaseSelecaoDialogComponent {
  ProvaFase = ProvaFase
  faseSelecionada: ProvaFase | null = null

  constructor(public dialogRef: MatDialogRef<FaseSelecaoDialogComponent>) {}

  confirmar(): void {
    this.dialogRef.close(this.faseSelecionada)
  }

  cancelar(): void {
    this.dialogRef.close(null)
  }
}
